import getClassNames from 'classnames';
import React from 'react';
import Element, { CommonProps } from '../../Element/Element';

import styles from '../Table.module.scss';

type TableHeaderCellProps = {
  /** If content doesn't fit to the cell, the word is cut and wrapped to the next row. This props adds word-break: break-all style to the cell */
  breakWord?: boolean;
  ref?: React.Ref<HTMLTableHeaderCellElement>;
} & Omit<CommonProps<'th'>, 'tagName' | 'ref'>;

const TableMobileHeadingCell: React.FunctionComponent<TableHeaderCellProps> = React.forwardRef(
  function TableMobileHeadingCell(
    { className, children, breakWord, ...props },
    ref: React.Ref<HTMLTableHeaderCellElement>
  ) {
    const classNames = getClassNames(
      styles.table_cell,
      styles.table_cell_heading,
      { [styles.table_cell__breakWord]: breakWord },
      className
    );

    return (
      <Element tagName="th" className={classNames} ref={ref} {...props}>
        {children}
      </Element>
    );
  }
);

export default TableMobileHeadingCell;
